<template>
    <v-autocomplete :value="value" @change="$emit('change', $event)" :items="experts" :filter="customFilter" item-value="id" :label="$t('Especialista')" :rules="rules">
        <template v-slot:selection="data"> {{ data.item.name }} ({{ data.item.user }}) </template>
        <template v-slot:item="data">
            <v-list-item-content>
                <v-list-item-title v-html="data.item.name"></v-list-item-title>
                <v-list-item-subtitle v-html="data.item.user"></v-list-item-subtitle>
            </v-list-item-content>
        </template>
    </v-autocomplete>
</template>

<script>
export default {
    name: "ExpertList",

    props: {
        value: {
            required: true,
        },
        rules: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            type: String,
            experts: null,
        };
    },

    methods: {
        customFilter(item, queryText) {
            const searchText = queryText.toLowerCase();
            return (item.name && item.name.toLowerCase().indexOf(searchText) > -1) || (item.user && item.user.toLowerCase().indexOf(searchText) > -1);
        },
        getExperts() {
            this.$http
                .get(`experts`)
                .then((result) => {
                    if (result) {
                        this.experts = result;
                    }
                })
                .catch(() => {
                    this.experts = null;
                });
        },
    },

    mounted() {
        this.getExperts();
    },
};
</script>